import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { clearAuthToken } from '../utils/api';

const navigation = [
  { to: '/dashboard', label: 'Books', icon: 'bi-book' },
  { to: '/clients', label: 'Clients', icon: 'bi-people' },
  { to: '/orders', label: 'Orders', icon: 'bi-receipt' },
  { to: '/users', label: 'Users', icon: 'bi-person-badge' },
  { to: '/subjects', label: 'Subjects', icon: 'bi-tags' },
  { to: '/classes', label: 'Classes', icon: 'bi-mortarboard' },
  { to: '/document-types', label: 'Document Types', icon: 'bi-file-earmark-text' },
];

const AdminLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const logout = () => {
    clearAuthToken();
    navigate('/login');
  };

  return (
    <div className={`app-wrapper ${sidebarOpen ? 'sidebar-open' : ''}`}>
      <header className="app-header">
        <button className="header-icon-button" type="button" aria-label="Toggle navigation" onClick={() => setSidebarOpen((open) => !open)}>
          <i className="bi bi-list" />
        </button>
        <div className="header-search">
          <i className="bi bi-search" />
          <span>DSS Administration</span>
        </div>
        <div className="header-spacer" />
        <div className="profile-pill">
          <span className="profile-avatar"><i className="bi bi-person" /></span>
          <span className="profile-copy"><strong>Administrator</strong><small>DSS Book Store</small></span>
        </div>
        <button type="button" className="logout-button" onClick={logout} aria-label="Log out">
          <i className="bi bi-box-arrow-right" /><span>Logout</span>
        </button>
      </header>

      <aside className="app-sidebar">
        <div className="sidebar-brand">
          <NavLink to="/dashboard" className="brand-link" onClick={() => setSidebarOpen(false)}>
            <span className="brand-mark"><i className="bi bi-book-half" /></span>
            <span className="brand-text">DSS <strong>Admin</strong></span>
          </NavLink>
        </div>
        <div className="sidebar-wrapper">
          <nav>
            <div className="sidebar-caption">Administration</div>
            <ul className="sidebar-menu" role="menu">
              {navigation.map((item) => (
                <li className="nav-item" key={item.to}>
                  <NavLink to={item.to} onClick={() => setSidebarOpen(false)} className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                    <i className={`nav-icon bi ${item.icon}`} />
                    <span>{item.label}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
          <div className="sidebar-version">v1.0.0</div>
        </div>
      </aside>
      <button className="sidebar-backdrop" aria-label="Close navigation" onClick={() => setSidebarOpen(false)} />

      <main className="app-main">{children}</main>
      <footer className="app-footer"><strong>DSS Book Store</strong><span>Order and inventory administration</span></footer>
    </div>
  );
};

export default AdminLayout;
